var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEKarta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 28,
    viewBox: "0 0 97 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 28V0H11.2085V3.40943H3.79286V11.6774H10.6117V15.0442H3.79286V24.5051H11.2085V28H0Z",
    fill: "url(#paint0_linear_1_447)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3877 28V0H18.1809V13.2543L24.7438 0H28.7074L22.0163 13.2969L28.7074 28H24.6583L18.1809 13.6377V28H14.3877ZM38.5647 7.20259L36.0076 19.3486H41.0792L38.5647 7.20259ZM30.2115 28L36.7748 0H40.312L46.875 28H43.0821L41.7182 22.5021H35.3257L34.0473 28H30.2115ZM54.9355 12.2741C56.5269 12.2741 57.6843 11.9543 58.4086 11.315C59.1337 10.6756 59.4955 9.50404 59.4955 7.79903C59.4955 6.00911 59.1547 4.80883 58.4728 4.19789C57.7911 3.58694 56.626 3.28162 54.9781 3.28162H53.4441V12.2741H54.9355ZM55.0207 15.6836H53.4441V28H49.651V0H55.1059C60.5325 0 63.2458 2.64228 63.2458 7.92684C63.2458 13.0978 60.5044 15.6836 55.0207 15.6836ZM69.9383 28V3.49464H64.7816V0H78.9308V3.49464H73.7744V28H69.9383ZM87.7529 7.20259L85.1956 19.3486H90.2671L87.7529 7.20259ZM79.3998 28L85.9624 0H89.5002L96.0632 28H92.27L90.9061 22.5021H84.5136L83.2352 28H79.3998Z",
    fill: "#2B2A29"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_447",
    x1: 0.343783,
    y1: -0.364493,
    x2: 0.343783,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109804,
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501961,
    stopColor: "#009846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85098,
    stopColor: "#00A0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEKarta);
export default __webpack_public_path__ + "static/media/eKarta.80bede4d.svg";
export { ForwardRef as ReactComponent };